import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { Cliente } from 'src/app/models/cliente';
import { GlobalService } from 'src/app/services/global.service';
import { ViaCep } from 'src/app/models/viacep';
import { ViaCepService } from 'src/app/services/via-cep.service';
import { Ibge } from 'src/app/models/ibge';
import { IbgeService } from "../../services/ibge.service";
import { CarregandoService } from 'src/app/services/carregando.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { Contato } from 'src/app/models/contato';
import { PlatformLocation } from "@angular/common";
import { Funcionario } from 'src/app/models/funcionario';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { MatDialog } from '@angular/material';
import { Segmentacao } from 'src/app/models/segmentacao';
import { SegmentacaoService } from 'src/app/services/segmentacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import swal from 'sweetalert2';
import { CnaeErroModalComponent } from 'src/app/modals/cnae-erro-modal/cnae-erro-modal.component';
import { GerenciarClassificacaoPersonalizadaModalComponent } from 'src/app/modals/gerenciar-classificacao-personalizada-modal/gerenciar-classificacao-personalizada-modal.component';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { globals } from 'src/app/globals';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { PremissasUsuario } from 'src/app/models/premissas-usuario';
import { FinanciamentoService } from "../../services/financiamento.services";
import { FontesConsultaCnpjModel } from "../../dominio/fontes-consulta-cnpj-model";
import { ConsultaCnpjService } from "../../core/services/consulta-cnpj.service";

// jquery
declare const $: any;

@Component({
  selector: "app-cadastrar-cliente",
  templateUrl: "./cadastrar-cliente.component.html",
  styleUrls: ["./cadastrar-cliente.component.scss"],
})
export class CadastrarClienteComponent
  implements OnInit, OnDestroy, AfterViewInit {
  // variáveis
  controleSolicitacaoToken: boolean = false;
  idCliente: number;
  cliente = new Cliente();
  clienteOriginal = new Cliente();
  editando = false;
  carregando = true;
  tipos = ["C", "I", "N"];
  tipoSelecionado = undefined;
  sexos = ["M", "F"];
  contato: Contato;
  vendedores: Funcionario[] = [];
  tiposDePessoa = [
    { id: 1, nome: "FÍSICA" },
    { id: 0, nome: "JURÍDICA" },
  ];
  estadosCivis = [
    "SOLTEIRO",
    "CASADO(A)",
    "AMIGADO(A)",
    "DIVORCIADO(A)",
    "VIUVO(A)",
  ];
  possuiVenda = false;
  gi = true;

  tiposDeDaMarketPlace = [
    { id: 0, nome: "Desconto" },
    { id: 1, nome: "Acréscimo" },
  ];
  tiposDeDaIntegracaoSolaryum = [
    { id: 0, nome: "Desconto" },
    { id: 1, nome: "Acréscimo" },
  ];
  tiposDeDaIntegracaoSub = [
    { id: 0, nome: "Desconto" },
    { id: 1, nome: "Acréscimo" },
  ];

  tiposDeDA = [
    { id: 0, nome: "Desconto" },
    { id: 1, nome: "Acréscimo" },
  ];

  tiposDePrecificacao = [
    { id: 0, nome: "Desconto" },
    { id: 1, nome: "Acréscimo" },
  ];

  public MASKS = MASKS;
  editavel = true;
  mascara = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
  };
  estados = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];
  tiposDeStatus = [
    { id: 0, nome: "Bloqueado" },
    { id: 1, nome: "Ativo" },
  ];
  estadoSelecionado = undefined;
  statusSelecionado = 1;
  cidades: Ibge[] = [];
  cidadeSelcionado = undefined;

  customPatterns = {
    V: { pattern: new RegExp("(,|[0-9]|-|\\.)") },
    0: { pattern: new RegExp("[0-9]") },
  };

  administrador = false;
  classificacao: Segmentacao[];
  classificacaoTexto: string = "Sem classificação";
  cnaesPremissas: { code: string; pure: string }[] = [];

  fidelidadeGoSolar = false;
  ativarVoucher = false;
  usarCentroDeDistribuicao = false;
  fornecedores = [];

  pUsarAcrescimo = false;

  inscricaoEstadualObg = false;

  usarMarketPlace = false;

  urlMarketPlace = "";

  usarIntegracaoSolaryum = false;

  modulosAtivos: Number[] = [];

  dadosSubAnterior: {
    integracaoSub?: boolean;
    daSub?: number;
    valorDaSub?: number;
    tokenSub?: number;
    urlSub?: number;
  } = {};

  usuarioLogado: UsuarioLogado;
  premissasSistema = new PremissasSistema();
  premissasUsuario = new PremissasUsuario();

  bloqueiaDadosEndereco: boolean = false;
  forcarAtualizacaoReceita: boolean = false;

  habilitaAbaAnaliseCredito: boolean = false;
  habilitaAbaFinanciadoras: boolean = false;

  fontesConsultaCnpj: FontesConsultaCnpjModel[] = [];
  camposAlteradosNaConsultaCadastral: { [key: string]: string } = {};

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private clienteService: ClienteService,
    private router: Router,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    private viaCepService: ViaCepService,
    private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService,
    private platformLocation: PlatformLocation,
    private funcionarioService: FuncionarioService,
    public dialog: MatDialog,
    private segmentacaoService: SegmentacaoService,
    private premissasService: PremissasService,
    private fornecedorService: FornecedorService,
    private financiamentoService: FinanciamentoService,
    private consultaCnpjService: ConsultaCnpjService
  ) { }

  async ngOnInit() {
    this.usuarioLogado = await this.globalService.consultaUsuario();
    await this.buscarPremissaControleSolicitacaoToken();
    this.buscarPremissasSistema();
    this.buscarPremissasUsuario();

    await this.buscarModulosAtivos();

    this.urlMarketPlace =
      globals.apiUrl + "/swagger/index.html?urls.primaryName=HubB2B";

    this.buscarPremissaUsarAcrescimo();

    this.administrador = await this.globalService.administrador();
    this.buscarInscricaoEstadualObg();
    this.buscarClassificacao();
    this.buscarCnaes();
    this.buscarUsarMarketPlace();
    this.buscarUsarIntegracaoSolaryum();
    this.buscarAtivarVoucher();
    this.buscarPremissaCentroDeDistribuicao();
    this.buscarFontesConsultaCnpj();
    this.consultaPodeVerAnaliseCredito();

    // se houver id, busca o cliente referente
    if (this.route.snapshot.paramMap.get("id")) {
      this.idCliente = Number(this.route.snapshot.paramMap.get("id"));
      this.editando = true;
      this.buscarCliente();
    } else if (history.state.idCliente) {
      this.idCliente = Number(history.state.idCliente);
      this.editando = true;
      this.gi = false;
      this.buscarCliente(true);
    } else {
      this.contato = history.state.contato;

      this.cliente = new Cliente();
      this.cliente.rg = this.contato.rg;
      this.cliente.inscEst = this.contato.inscEst;
      this.cliente.cnpj = this.contato.cnpj;
      this.cliente.cpf = this.contato.cnpj;
      this.cliente.nome = this.contato.razao;
      this.cliente.fantasia = this.contato.fantasia;
      this.cliente.contato = this.contato.nomeContato;
      this.cliente.rua = this.contato.logradouro;
      this.cliente.n = this.contato.nume;
      this.cliente.compl = this.contato.comp;
      this.cliente.bairro = this.contato.bairro;
      this.cliente.cidade = this.contato.cidade;
      this.cliente.uf = this.contato.uf;
      this.cliente.cep = this.contato.cep;
      this.cliente.email = this.contato.email;
      this.cliente.cel = this.contato.telefone;
      this.cliente.ibge = this.contato.ibge;
      this.cliente.tipo = this.contato.tipo;
      this.cliente.vendedor = this.contato.vendedor;
      this.cliente.cargoContato = this.contato.cargoContato;
      this.cliente.site = this.contato.site;
      this.cliente.podeAlterarGestao = true;
      this.cliente.codSuframa = this.contato.codSuframa;
      this.cliente.dataAtualizacaoReceita = this.contato.dataAtualizacaoReceita;
      this.cliente.fonteAtualizacaoReceita = this.contato.fonteAtualizacaoReceita;
      this.cliente.listaCnaes = this.contato.listaCnaes;
      this.cliente.optanteSimples = this.contato.optanteSimples;
      this.cliente.dataSituacaoSimples = this.contato.dataSituacaoSimples;
      this.cliente.optanteSimei = this.contato.optanteSimei;
      this.cliente.dataSituacaoSimei = this.contato.dataSituacaoSimei;

      this.atualizaDadosCliente();
      this.clienteOriginal = Object.assign({}, this.cliente);

      this.dadosSubAnterior = {};
    }
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra("buscarPremissasSistema");

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde("buscarPremissasSistema");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissasSistema");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissasUsuario() {
    this.carregandoService.mostra("buscarPremissasUsuario");

    this.premissasService.consultarPremissasUsuario().subscribe(
      (premissas) => {
        this.premissasUsuario = premissas;
        this.carregandoService.esconde("buscarPremissasUsuario");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissasUsuario");
        this.notificacaoService.erro(erro);
      }
    );
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some((p) => p === modulo);
  }

  async buscarModulosAtivos() {
    try {
      this.carregandoService.mostra("buscarModulosAtivos");

      this.modulosAtivos = await this.premissasService
        .consultarModulosAtivos()
        .toPromise();

      this.carregandoService.esconde("buscarModulosAtivos");
    } catch (erro) {
      this.carregandoService.esconde("buscarModulosAtivos");
      this.notificacaoService.erro(erro);
    }
  }

  buscarPremissaUsarAcrescimo() {
    this.carregandoService.mostra("buscarPremissaUsarAcrescimo");
    this.premissasService.consultarUsarAcrescimo().subscribe(
      (f) => {
        if (f.valor) {
          this.pUsarAcrescimo = true;
        }

        this.carregandoService.esconde("buscarPremissaUsarAcrescimo");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissaUsarAcrescimo");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarInscricaoEstadualObg() {
    this.carregandoService.mostra("buscarInscricaoEstadualObg");
    this.premissasService.consultarInscricaoEstadualObg().subscribe(
      (dados) => {
        this.inscricaoEstadualObg = dados.valor;
        this.carregandoService.esconde("buscarInscricaoEstadualObg");
      },
      (erro) => {
        this.carregandoService.esconde("buscarInscricaoEstadualObg");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra("buscarPremissaCentroDeDistribuicao");
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (centro) => {
        this.carregandoService.esconde("buscarPremissaCentroDeDistribuicao");
        if (centro.valor) {
          this.usarCentroDeDistribuicao = true;
          this.buscarFornecedores();
        }
      },
      (err) => {
        this.carregandoService.esconde("buscarPremissaCentroDeDistribuicao");
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarFornecedores() {
    this.carregandoService.mostra("buscarFornecedores");
    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.carregandoService.esconde("buscarFornecedores");
        this.fornecedores = forn;
      },
      (err) => {
        this.carregandoService.esconde("buscarFornecedores");
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarUsarMarketPlace() {
    this.carregandoService.mostra("buscarUsarMarketPlace");
    this.premissasService.consultarUsarMarketPlace().subscribe(
      (fg) => {
        if (fg.valor) {
          this.usarMarketPlace = fg.valor;
        }
        this.carregandoService.esconde("buscarUsarMarketPlace");
      },
      (erro) => {
        this.carregandoService.esconde("buscarUsarMarketPlace");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarUsarIntegracaoSolaryum() {
    this.carregandoService.mostra("buscarUsarIntegracaoSolaryum");
    this.premissasService.consultarIntegracaoSolaryum().subscribe(
      (fg) => {
        if (fg.valor) {
          this.usarIntegracaoSolaryum = fg.valor;
        }
        this.carregandoService.esconde("buscarUsarIntegracaoSolaryum");
      },
      (erro) => {
        this.carregandoService.esconde("buscarUsarIntegracaoSolaryum");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarAtivarVoucher() {
    this.carregandoService.mostra("consultarAtivarVoucher");
    this.premissasService.consultarAtivarVoucher().subscribe(
      (av) => {
        if (av.valor) {
          this.ativarVoucher = av.valor;
        }
        this.carregandoService.esconde("consultarAtivarVoucher");
      },
      (erro) => {
        this.carregandoService.esconde("consultarAtivarVoucher");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarVendedores() {
    this.carregandoService.mostra("buscarVendedores");

    this.funcionarioService
      .consultarFuncionariosInclusive([
        this.usuarioLogado.id,
        this.cliente.vendedor ? this.cliente.vendedor : -1,
      ])
      .subscribe(
        (dados) => {
          this.vendedores = dados;
          this.carregandoService.esconde("buscarVendedores");
        },
        (erro) => {
          this.carregandoService.esconde("buscarVendedores");
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarCnaes() {
    this.carregandoService.mostra("buscarCnaes");

    this.premissasService.consultarCnaes().subscribe(
      (cnaes) => {
        if (cnaes.valor) {
          this.cnaesPremissas = cnaes.valor.split(";").map((p) => ({
            code:
              p[0] + p[1] + "." + p[2] + p[3] + "-" + p[4] + "-" + p[5] + p[6],
            pure: p,
          }));
        }

        this.carregandoService.esconde("buscarCnaes");
      },
      (erro) => {
        this.carregandoService.esconde("buscarCnaes");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarClassificacao() {
    this.carregandoService.mostra("buscarClassificacao");

    this.segmentacaoService.consultar().subscribe(
      (dados) => {
        this.classificacao = dados;

        this.carregandoService.esconde("buscarClassificacao");
      },
      (erro) => {
        this.carregandoService.esconde("buscarClassificacao");
        this.notificacaoService.erro(erro);
      }
    );
  }

  focalizaNumero() {
    $("#numero").focus();
  }

  buscarCliente(transformando?) {
    this.carregandoService.mostra("buscaCliente");

    this.clienteService
      .consultarPorIdCliente(this.idCliente, this.gi)
      .subscribe(
        (cli) => {
          this.cliente = cli;
          this.clienteOriginal = Object.assign({}, cli);
          this.dadosSubAnterior = {
            daSub: this.cliente.daSub,
            integracaoSub: this.cliente.integracaoSub,
            tokenSub: this.cliente.tokenSub,
            urlSub: this.cliente.urlSub,
            valorDaSub: this.cliente.valorDaSub,
          };

          if (this.premissasUsuario.buscarEnderecoSomentePorReceita) {
            this.bloqueiaDadosEndereco = true;
            this.verificaUltAtualizacaoReceita(this.cliente.id);
          }

          if (transformando) {
            this.cliente.podeAlterarGestao = true;
          }

          this.atualizaDadosCliente();

          if (
            this.premissasSistema.vinculoClassificacaoPorApi &&
            this.cliente.segm !== null &&
            this.cliente.segm !== undefined
          ) {
            this.classificacaoTexto = this.classificacao.find(
              (c) => c.id === this.cliente.segm
            ).descricao;
          }
        },
        (erro) => {
          this.carregandoService.esconde("buscaCliente");
          this.notificacaoService.erro(erro);
        }
      );
  }

  ngAfterViewInit(): void {
    this.rodaScriptTabEnter();
  }

  rodaScriptTabEnter() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  atualizaDadosCliente() {
    // this.cliente.dtNasc = new DatePipe('pt-BR').transform(this.cliente.dtNasc, 'MM-dd-yyyy');
    // this.cliente.dtAbert = new DatePipe('pt-BR').transform(this.cliente.dtAbert, 'y-MM-dd');

    // this.cliente.dtNasc = this.cliente.dtNasc ? new Date(this.cliente.dtNasc).toISOString() : undefined;
    // this.cliente.dtAbert = this.cliente.dtAbert ? new Date(this.cliente.dtAbert).toISOString() : undefined;
    this.estadoSelecionado = this.estados.find((s) => s === this.cliente.uf);
    this.statusSelecionado = this.tiposDeStatus.find(
      (s) => s.id === this.cliente.ativo
    )
      ? this.tiposDeStatus.find((s) => s.id === this.cliente.ativo).id
      : 1;

    // this.tipoSelecionado = this.tipos.find(s => s === this.cliente.tipo);

    this.rodaScriptTabEnter();

    this.buscarVendedores();
    this.buscarCidades();

    this.carregandoService.esconde("buscaCliente");
    this.carregando = false;
  }

  classificacaoPersonalizada() {
    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(
      GerenciarClassificacaoPersonalizadaModalComponent,
      {
        width: largura > 730 ? "700px" : $("body").width().toString() + "px",
        data: {
          editavel: true,
          tabelas: this.cliente.camposPersonalizadosMontar,
        },
        panelClass: "modal-card",
      }
    );

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.cliente.camposPersonalizadosMontar = result;
      }
    });
  }

  async validarSalvar() {
    return new Promise((resolve, reject) => {
      const largura = Number($("body").width());
      const dialogRef = this.dialog.open(CnaeErroModalComponent, {
        width: largura > 830 ? "800px" : $("body").width().toString() + "px",
        data: {
          cnaesCliente: this.cliente.listaCnaes,
          cnaesPremissas: this.cnaesPremissas,
        },
        panelClass: "modal-card",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined && result.liberarSemCnae) {
          resolve();
        } else {
          reject();
        }
      });
    });
  }

  async salvar() {
    if (this.cliente.tipo === 0) {
      if (!this.validarCnaesCNPJ()) {
        try {
          await this.validarSalvar();
        } catch (err) {
          return;
        }
      }
    }

    this.carregandoService.mostra("salvaCliente");

    this.cliente.uf = this.estadoSelecionado;
    this.cliente.id = this.idCliente;
    this.cliente.ativo = this.statusSelecionado;
    this.cliente.ibge = this.cidadeSelcionado;
    this.cliente.cidade = this.cidades.find((s) => s.cod === this.cliente.ibge)
      ? this.cidades.find((s) => s.cod === this.cliente.ibge).cidade
      : "";

    if (
      this.cliente.descontoGI !== undefined &&
      this.cliente.descontoGI !== null
    ) {
      this.cliente.descontoGI = Number(this.cliente.descontoGI);
    }
    if (
      this.cliente.descontoMaximoGI !== undefined &&
      this.cliente.descontoMaximoGI !== null
    ) {
      this.cliente.descontoMaximoGI = Number(this.cliente.descontoMaximoGI);
    }

    if (
      this.cliente.descontoMaximoGI !== undefined &&
      this.cliente.descontoMaximoGI !== null
    ) {
      this.cliente.descontoMaximoGI = Number(this.cliente.descontoMaximoGI);
    }

    if (this.cliente.segm !== undefined && this.cliente.segm !== null) {
      this.cliente.segm = Number(this.cliente.segm);
    }

    // if (this.cliente.marketPlace)
    // {
    //   this.cliente.daMP = 0;
    //   this.cliente.daKitMP = 0;
    // }

    if (
      this.cliente.descontoMaximoGI !== undefined &&
      this.cliente.descontoMaximoGI !== null
    ) {
      this.cliente.descontoMaximoGI = Number(this.cliente.descontoMaximoGI);
    }

    if (
      this.cliente.acrescimoGI !== undefined &&
      this.cliente.acrescimoGI !== null
    ) {
      this.cliente.acrescimoGI = Number(this.cliente.acrescimoGI);
    }

    if (
      this.cliente.valorDaMP !== undefined &&
      this.cliente.valorDaMP !== null
    ) {
      this.cliente.valorDaMP = Number(this.cliente.valorDaMP);
    }

    if (
      this.cliente.valorDaKitMP !== undefined &&
      this.cliente.valorDaKitMP !== null
    ) {
      this.cliente.valorDaKitMP = Number(this.cliente.valorDaKitMP);
    }

    if (
      this.cliente.estoqueMP !== undefined &&
      this.cliente.estoqueMP !== null
    ) {
      this.cliente.estoqueMP = Number(this.cliente.estoqueMP);
    }

    if (
      this.cliente.valorDaIS !== undefined &&
      this.cliente.valorDaIS !== null
    ) {
      this.cliente.valorDaIS = Number(this.cliente.valorDaIS);
    }

    if (
      this.cliente.valorDaKitIS !== undefined &&
      this.cliente.valorDaKitIS !== null
    ) {
      this.cliente.valorDaKitIS = Number(this.cliente.valorDaKitIS);
    }

    if (
      this.cliente.estoqueIS !== undefined &&
      this.cliente.estoqueIS !== null
    ) {
      this.cliente.estoqueIS = Number(this.cliente.estoqueIS);
    }

    if (
      this.cliente.valorDaSub !== undefined &&
      this.cliente.valorDaSub !== null
    ) {
      this.cliente.valorDaSub = Number(this.cliente.valorDaSub);
    }

    // Verifica a integridade da consulta cadastral
    if (
      !this.bloqueiaDadosEndereco &&
      !this.verificaIntegridadeDaConsultaCadastral()
    ) {
      this.cliente.dataAtualizacaoReceita = null;
      this.cliente.fonteAtualizacaoReceita = null;
    }

    if (!this.idCliente) {
      const url = location.origin + this.platformLocation.getBaseHrefFromDOM();

      this.clienteService
        .inserir(this.cliente, this.contato.idGIContato, url)
        .subscribe(
          () => {
            this.notificacaoService.sucesso("Integrador salvo com sucesso!!!");
            this.router.navigate(["/integradores"]).then(() => {
              this.carregandoService.esconde("salvaCliente");
            });
          },
          (erro) => {
            this.carregandoService.esconde("salvaCliente");
            this.notificacaoService.erro(erro);
          }
        );
    } else {
      this.clienteService.atualizar(this.cliente).subscribe(
        () => {
          this.notificacaoService.sucesso(
            "Integrador atualizado com sucesso!!!"
          );
          this.router.navigate(["/integradores"]).then(() => {
            this.carregandoService.esconde("salvaCliente");
          });
        },
        (erro) => {
          this.carregandoService.esconde("salvaCliente");
          this.notificacaoService.erro(erro);
        }
      );
    }
  }

  ngOnDestroy(): void { }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra("buscaEnderecoPorCep");
    this.viaCepService.obterEndereco(this.cliente.cep).subscribe(
      (viaCep: ViaCep) => {
        this.cliente.bairro = viaCep.bairro;
        // this.cliente.compl = viaCep.complemento;
        this.cliente.rua = viaCep.logradouro;
        this.estadoSelecionado = viaCep.uf;
        this.cliente.ibge = viaCep.ibge;

        this.buscarCidades();

        this.focalizaNumero();

        this.carregandoService.esconde("buscaEnderecoPorCep");
      },
      (erro) => {
        this.cliente.bairro = "";
        // this.cliente.compl = viaCep.complemento;
        this.cliente.rua = "";
        this.estadoSelecionado = undefined;
        this.cliente.ibge = "";
        this.cidadeSelcionado = undefined;
        this.carregandoService.esconde("buscaEnderecoPorCep");
        this.notificacaoService.erro(
          "Não foi possível acessar o serviço de CEP ou CEP Inválido!"
        );
      }
    );
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra("buscaCidades");
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe(
      (ibges: Ibge[]) => {
        this.cidades = ibges;

        if (nomeCidade) {
          this.cidadeSelcionado = this.cidades.find(
            (s) =>
              this.utilitarioService.remover_acentos_espaco(
                s.cidade.toLowerCase().trim()
              ) ===
              this.utilitarioService.remover_acentos_espaco(
                nomeCidade.toLowerCase().trim()
              )
          )
            ? this.cidades.find(
              (s) =>
                this.utilitarioService.remover_acentos_espaco(
                  s.cidade.toLowerCase().trim()
                ) ===
                this.utilitarioService.remover_acentos_espaco(
                  nomeCidade.toLowerCase().trim()
                )
            ).cod
            : undefined;
        } else {
          this.cidadeSelcionado = this.cidades.find(
            (s) => s.cod === this.cliente.ibge
          )
            ? this.cidades.find((s) => s.cod === this.cliente.ibge).cod
            : "";
        }

        this.carregandoService.esconde("buscaCidades");
      },
      (erro) => {
        this.carregandoService.esconde("buscaCidades");
      }
    );
  }

  validarCnaesCNPJ() {
    let valido = false;

    if (
      !this.cnaesPremissas.length ||
      (!this.cliente.listaCnaes.length && !this.cnaesPremissas.length)
    ) {
      return true;
    }

    this.cliente.listaCnaes.forEach((cnae) => {
      if (!valido && this.cnaesPremissas.find((x) => x.pure === cnae)) {
        valido = true;
      }
    });

    return valido;
  }

  gerarTokenApiEstoque() {
    this.carregandoService.mostra("gerarTokenApiEstoque");
    this.clienteService.gerarTokenIntegracao().subscribe(
      (resultado: any) => {
        this.cliente.tokenApiEstoque = resultado.token;

        this.carregandoService.esconde("gerarTokenApiEstoque");
      },
      (erro) => {
        this.carregandoService.esconde("gerarTokenApiEstoque");
        this.notificacaoService.erro(
          "Não foi possível gerar o token"
        );
      }
    );
  }

  gerarTokenIntegracao() {
    this.carregandoService.mostra("gerarTokenIntegracao");
    this.clienteService.gerarTokenIntegracao().subscribe(
      (resultado: any) => {
        this.cliente.tokenGI = resultado.token;

        this.carregandoService.esconde("gerarTokenIntegracao");
      },
      (erro) => {
        this.carregandoService.esconde("gerarTokenIntegracao");
        this.notificacaoService.erro(
          "Não foi possível gerar o token de integração"
        );
      }
    );
  }

  async gerarTokenMarketPlace() {
    if (this.controleSolicitacaoToken) {
      const idtoken = await this.solicitarCriacaoDeToken();
      this.cliente.tokenMP = await this.aprovarSolicitacao(idtoken);
    } else {
      this.carregandoService.mostra("gerarTokenMarketPlace");
      this.clienteService.gerarTokenIntegracao().subscribe(
        async (resultado: any) => {
          this.cliente.tokenMP = resultado.token;

          this.carregandoService.esconde("gerarTokenMarketPlace");
        },
        (erro) => {
          this.carregandoService.esconde("gerarTokenMarketPlace");
          this.notificacaoService.erro(
            "Não foi possível gerar o token de HubB2B"
          );
        }
      );
    }
  }

  solicitarCriacaoDeToken(): Promise<number> {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra("solicitarCriacaoDeToken");
      this.clienteService.solicitarCriacaoDeToken(this.idCliente).subscribe(
        (resultado: any) => {
          this.carregandoService.esconde("solicitarCriacaoDeToken");
          this.notificacaoService.sucesso(
            "Solicitação de token HubB2B feita com sucesso."
          );
          resolve(resultado);
        },
        (erro) => {
          this.carregandoService.esconde("solicitarCriacaoDeToken");
          this.notificacaoService.erro(
            "Não foi possível solicitar o token de HubB2B"
          );
          reject();
        }
      );
    });
  }

  async aprovarSolicitacao(idToken: number): Promise<string> {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra("aprovarSolicitacao");
      this.clienteService.aprovarSolicitacao(idToken.toString()).subscribe(
        (res) => {
          this.carregandoService.esconde("aprovarSolicitacao");
          this.notificacaoService.sucesso("Solicitação aprovada com sucesso!");
          resolve(res.token);
        },
        (err) => {
          this.carregandoService.esconde("aprovarSolicitacao");
          this.notificacaoService.erro(err);
          reject();
        }
      );
    });
  }

  gerarTokenIntegracaoSolaryum() {
    this.carregandoService.mostra("gerarTokenIntegracaoSolaryum");
    this.clienteService.gerarTokenIntegracao().subscribe(
      (resultado: any) => {
        this.cliente.tokenIS = resultado.token;

        this.carregandoService.esconde("gerarTokenIntegracaoSolaryum");
      },
      (erro) => {
        this.carregandoService.esconde("gerarTokenIntegracaoSolaryum");
        this.notificacaoService.erro(
          "Não foi possível gerar o token de Integração Solaryum"
        );
      }
    );
  }

  gerarTokenIntegracaoSub() {
    this.carregandoService.mostra("gerarTokenIntegracaoSub");
    this.clienteService.gerarTokenIntegracao().subscribe(
      (resultado: any) => {
        this.cliente.tokenSub = resultado.token;

        this.carregandoService.esconde("gerarTokenIntegracaoSub");
      },
      (erro) => {
        this.carregandoService.esconde("gerarTokenIntegracaoSub");
        this.notificacaoService.erro(
          "Não foi possível gerar o token de Integração Distribuidor"
        );
      }
    );
  }

  verificaCep() {
    if (!this.cliente.cep.includes("_")) this.buscarEnderecoPorCep();
  }

  atualizarCep() {
    window.open("https://viacep.com.br/cep/", "_blank");

    // const largura = Number(($('body').width()));

    // const dialogRef = this.dialog.open(AtualizaCepModalComponent, {
    //   width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
    //   data: {},
    //   panelClass: 'modal-card'
    // });

    // dialogRef.afterClosed().subscribe((result: any) => {

    // });
  }

  alterouDaGI() {
    if (this.cliente.daGI === 0) {
      this.cliente.acrescimoGI = 0;
    } else {
      this.cliente.descontoMaximoGI = 0;
    }

    // if (this.cliente.descontoMaximoGI !== undefined && this.cliente.descontoMaximoGI !== null){
    //   this.cliente.descontoMaximoGI = Number(this.cliente.descontoMaximoGI);
    // }

    // if (this.cliente.acrescimoGI !== undefined && this.cliente.acrescimoGI !== null){
    //   this.cliente.acrescimoGI = Number(this.cliente.acrescimoGI);
    // }
  }

  async enviarDadosSub() {
    if (!this.compararDadosSub()) {
      swal({
        title: "ATENÇÃO!!",
        html: "Houveram mudanças nos dados da integração com o subdistribuidor! Por favor, salve o cadastro e tente novamente!!!",
        type: "warning",
        confirmButtonClass: "btn btn-warning",
        buttonsStyling: false,
        allowEnterKey: false,
      });
    } else {
      swal({
        title: "Atenção!!",
        html: "Deseja realmente enviar os dados para o subdistribuidor?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-info",
        cancelButtonClass: "btn btn-danger",
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            this.carregandoService.limpaProgresso();
            this.carregandoService.mostraProgresso();

            await this.clienteService
              .enviarDadosSub(this.idCliente)
              .toPromise();

            this.carregandoService.escondeProgresso();

            this.notificacaoService.sucesso("Dados enviados com sucesso!!!");
          } catch (erro) {
            this.carregandoService.escondeProgresso();
            this.notificacaoService.erro(erro);
          }
        }
      });
    }
  }

  compararDadosSub() {
    return (
      this.dadosSubAnterior.daSub === this.cliente.daSub &&
      this.dadosSubAnterior.integracaoSub === this.cliente.integracaoSub &&
      this.dadosSubAnterior.tokenSub === this.cliente.tokenSub &&
      this.dadosSubAnterior.urlSub === this.cliente.urlSub &&
      Number(this.dadosSubAnterior.valorDaSub) ===
      Number(this.cliente.valorDaSub)
    );
  }

  buscarFontesConsultaCnpj() {
    this.carregandoService.mostra("buscarFontesConsultaCnpj");

    this.consultaCnpjService.buscarFontes().subscribe(
      (data) => {
        this.fontesConsultaCnpj = data.results;
        this.carregandoService.esconde("buscarFontesConsultaCnpj");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFontesConsultaCnpj");
        this.notificacaoService.erro(erro);
      }
    );
  }

  consultarCnpj(idFonte: string | null) {
    this.carregandoService.mostra("consultarCnpj");
    this.camposAlteradosNaConsultaCadastral = {};

    this.consultaCnpjService.consultar(this.cliente.cnpj, idFonte).subscribe(
      (data) => {
        const resultado = data.result;
        const fantasia = resultado.nomeFantasia
          ? resultado.nomeFantasia
          : resultado.razaoSocial;
        const dataAberturaCliente = new Date(this.cliente.dtAbert);
        const dataAberturaClienteLog = `${dataAberturaCliente.getDate()}${dataAberturaCliente.getMonth()}${dataAberturaCliente.getFullYear()}`;
        const dataAberturaConsulta = new Date(resultado.dataAbertura);
        const dataAberturaConsultaLog = `${dataAberturaConsulta.getDate()}${dataAberturaConsulta.getMonth()}${dataAberturaConsulta.getFullYear()}`;
        const registroEstadual = resultado.registrosEstaduais
          ? resultado.registrosEstaduais.find((r) => r.uf === resultado.uf)
          : null;
        const ieConsulta = registroEstadual != null ? registroEstadual.ie : null;
        let telefone: string | null = null;

        if (resultado.telefones && resultado.telefones.length > 0) {
          telefone = resultado.telefones[0];
        }

        let email: string | null = null;

        if (resultado.emails && resultado.emails.length > 0) {
          email = resultado.emails[0];
        }

        this.camposAlteradosNaConsultaCadastral["cnpj"] = resultado.cnpj;

        if (this.cliente.nome !== resultado.razaoSocial) {
          this.camposAlteradosNaConsultaCadastral["nome"] =
            resultado.razaoSocial;
          this.cliente.nome = resultado.razaoSocial;
        }

        if (this.cliente.fantasia !== fantasia) {
          this.camposAlteradosNaConsultaCadastral["fantasia"] = fantasia;
          this.cliente.fantasia = fantasia;
        }

        if (dataAberturaClienteLog !== dataAberturaConsultaLog) {
          this.camposAlteradosNaConsultaCadastral["dtAbert"] = dataAberturaConsultaLog;
          this.cliente.dtAbert = dataAberturaConsulta;
        }

        if (this.cliente.rua !== resultado.logradouro) {
          this.camposAlteradosNaConsultaCadastral["rua"] = resultado.logradouro;
          this.cliente.rua = resultado.logradouro;
        }

        if (resultado.numero && this.cliente.n !== resultado.numero) {
          this.camposAlteradosNaConsultaCadastral["n"] = resultado.numero;
          this.cliente.n = resultado.numero;
        }

        if (resultado.complemento && this.cliente.compl !== resultado.complemento) {
          this.camposAlteradosNaConsultaCadastral["compl"] =
            resultado.complemento;
          this.cliente.compl = resultado.complemento;
        }

        if (this.cliente.bairro !== resultado.bairro) {
          this.camposAlteradosNaConsultaCadastral["bairro"] = resultado.bairro;
          this.cliente.bairro = resultado.bairro;
        }

        this.cliente.ibge = undefined;
        this.estadoSelecionado = resultado.uf;

        if (this.cliente.cep !== resultado.cep) {
          this.camposAlteradosNaConsultaCadastral["cep"] = resultado.cep;
          this.cliente.cep = resultado.cep;
        }

        this.buscarCidades(resultado.cidade);

        if (this.premissasSistema.preencherTelefoneEmailConsultaCnpj) {
          if (telefone && this.cliente.tel1 !== telefone) {
            this.camposAlteradosNaConsultaCadastral["tel1"] = telefone;
            this.cliente.tel1 = telefone;
          }

          if (email && this.cliente.email !== email) {
            this.camposAlteradosNaConsultaCadastral["email"] = email;
            this.cliente.email = email;
          }
        }

        this.cliente.listaCnaes = resultado.atividadesEconomicas.map((x) => x.codigo);
        this.cliente.optanteSimples = resultado.simples != null ? resultado.simples.optante : null;
        this.cliente.dataSituacaoSimples = resultado.simples != null ? resultado.simples.desde : null;
        this.cliente.optanteSimei = resultado.simei != null ? resultado.simei.optante : null;
        this.cliente.dataSituacaoSimei = resultado.simei != null ? resultado.simei.desde : null;

        if (ieConsulta && this.cliente.inscEst !== ieConsulta) {
          this.camposAlteradosNaConsultaCadastral["inscEst"] = ieConsulta;
          this.cliente.inscEst = ieConsulta;
        }

        this.cliente.dataAtualizacaoReceita = resultado.ultimaAtualizacao ? new Date(resultado.ultimaAtualizacao) : new Date(Date.now());
        this.cliente.fonteAtualizacaoReceita = resultado.fonte;

        this.forcarAtualizacaoReceita = false;

        this.carregandoService.esconde("consultarCnpj");
      },
      (erro) => {
        this.carregandoService.esconde("consultarCnpj");
        this.notificacaoService.erro(erro);
      }
    );
  }

  verificaIntegridadeDaConsultaCadastral(): boolean {
    const campos = [
      "cnpj",
      "nome",
      "inscEst",
      "rua",
      "n",
      "compl",
      "bairro",
      "cep",
    ];

    const integridade = campos.map((campo) => {
      if (this.cliente[campo] !== this.clienteOriginal[campo]) {
        return (
          campo in this.camposAlteradosNaConsultaCadastral &&
          this.cliente[campo] === this.camposAlteradosNaConsultaCadastral[campo]
        );
      }

      return true;
    });

    return integridade.every((i) => i);
  }

  verificaCampoAlteradoNaConsultaCadastral(campo: string): boolean {
    return campo in this.camposAlteradosNaConsultaCadastral;
  }

  buscarPremissaControleSolicitacaoToken() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra("buscaPremissaControleSolicitacaoToken");
      this.premissasService
        .consultarControleSolicitacaoTokenIntegrador()
        .subscribe(
          (resultado: any) => {
            this.controleSolicitacaoToken = resultado.valor;
            this.carregandoService.esconde(
              "buscaPremissaControleSolicitacaoToken"
            );
            resolve();
          },
          (erro) => {
            this.carregandoService.esconde(
              "buscaPremissaControleSolicitacaoToken"
            );
            reject();
          }
        );
    });
  }

  onChangeMarketPlace(event) {
    if (
      this.controleSolicitacaoToken &&
      !event.checked &&
      this.cliente.tokenMP
    ) {
      swal({
        title: "ATENÇÃO!!",
        html: "É necessária a interação com a tela Solicitações de Token para bloquear o acesso desse cliente.",
        type: "warning",
        confirmButtonClass: "btn btn-warning",
        buttonsStyling: false,
        allowEnterKey: false,
      });

      event.preventDefault();

      if (event.checked && this.cliente.tokenMP) {
        this.cliente.marketPlace = true;
      }
    }

    this.cliente.podeReceberItensMP = true;
  }

  verificaUltAtualizacaoReceita(id) {
    this.carregandoService.mostra("verificaUltAtualizacaoReceita");
    this.clienteService.forcaAtualizacaoReceita(id).subscribe(
      (data) => {
        this.forcarAtualizacaoReceita = data.result;
        this.carregandoService.esconde("verificaUltAtualizacaoReceita");
      },
      (erro) => {
        this.carregandoService.esconde("verificaUltAtualizacaoReceita");
        console.error(erro);
      }
    );
  }

  geraTextoSimplesNacional() {
    return this.clienteService.geraTextoSimplesNacional(this.cliente);
  }

  geraTextoSimei() {
    return this.clienteService.geraTextoSimei(this.cliente);
  }

  geraTextoAtualizacaoReceita() {
    return this.clienteService.geraTextoAtualizacaoReceita(this.cliente);
  }

  validaPercetual(campo) {
    if (Number(this.cliente[campo]) < 0)
      this.cliente[campo] = 0;
    else if (Number(this.cliente[campo]) > 100)
      this.cliente[campo] = 100;
  }

  consultaPodeVerAnaliseCredito() {
    this.carregandoService.mostra("consultaPodeVerAnaliseCredito");
    this.funcionarioService.consultaPodeVerAnaliseCredito().subscribe(
      (data) => {
        this.habilitaAbaAnaliseCredito = data;

        if (data === true && this.possuiModulo(15)) {
          this.buscarFinanciamentoConfig();
        } else {
          this.habilitaAbaFinanciadoras = false;
        }

        this.carregandoService.esconde("consultaPodeVerAnaliseCredito");
      },
      (error) => {
        this.habilitaAbaAnaliseCredito = false;
        this.habilitaAbaFinanciadoras = false;

        this.notificacaoService.erro(error);
        this.carregandoService.esconde("consultaPodeVerAnaliseCredito");
      });
  }

  buscarFinanciamentoConfig() {
    this.carregandoService.mostra("buscarFinanciamentoConfig");

    this.financiamentoService.buscar().subscribe(
      (config) => {
        this.habilitaAbaFinanciadoras = config.result.ativo;
        this.carregandoService.esconde("buscarFinanciamentoConfig");
      },
      (erro) => {
        this.habilitaAbaFinanciadoras = false;

        this.carregandoService.esconde("buscarFinanciamentoConfig");
        this.notificacaoService.erro(erro);
      }
    );
  }
}
